import React from 'react';
import PropTypes from 'prop-types';

class CheckableItems extends React.Component {
  static propTypes = {
    children: PropTypes.func.isRequired
  };

  state = {
    checkedItems: new Set()
  };

  isChecked = (item) => {
    const { checkedItems } = this.state;

    return checkedItems.has(item);
  };

  checkedItems = () => {
    const { checkedItems } = this.state;

    return Array.from(checkedItems);
  };

  isGroupChecked = (group) => {
    const { checkedItems } = this.state;

    return group.length && group.every((item) => checkedItems.has(item));
  };

  toggleGroup = (group) => () => {
    const { checkedItems } = this.state;
    let newItems;
    if (this.isGroupChecked(group)) {
      newItems = new Set([...checkedItems].filter((item) => !group.includes(item)));
    } else {
      group.forEach((item) => {
        checkedItems.add(item);
      });
      newItems = checkedItems;
    }
    this.setState({
      checkedItems: newItems
    });
  };

  render() {
    const { children } = this.props;

    return children(this.checkedItems(), {
      isChecked: this.isChecked,
      isGroupChecked: this.isGroupChecked,
      toggleGroup: this.toggleGroup
    });
  }
}

export default CheckableItems;
